var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 81,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.728 75.673a14.759 14.759 0 01-6.583-9.464 127.425 127.425 0 01-.055-51.797A14.645 14.645 0 015.4 9.046a15.393 15.393 0 019.836-6.325 143.214 143.214 0 0153.877-.064l-.006.015a15.756 15.756 0 015.591 2.21 14.815 14.815 0 016.576 9.471 127.52 127.52 0 01.053 51.793 14.576 14.576 0 01-2.308 5.366 15.416 15.416 0 01-9.844 6.326 143.244 143.244 0 01-53.87.056 15.727 15.727 0 01-5.577-2.221z",
    fill: "#C2E9FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.997 35.737a7.912 7.912 0 100-15.824 7.912 7.912 0 000 15.824z",
    stroke: "#00A1DC",
    strokeWidth: 3.072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.446 57.778a2.551 2.551 0 002.395-1.681c.119-.327.17-.674.15-1.02-.303-5.186-1.21-7.219-2.736-8.744-3.814-3.815-26.703-3.815-30.518 0-1.525 1.525-2.432 3.558-2.735 8.744a2.55 2.55 0 001.535 2.49c.319.138.662.21 1.01.21h30.9z",
    stroke: "#00A1DC",
    strokeWidth: 3.072
  }))));
}
export default SvgPerson;